import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Box,
    Stack,
    Typography,
    Divider,
    Button,
    CardMedia,
    Card,
    CardContent,
    ButtonGroup,
    IconButton,
    Paper,
    Chip,
    // Container,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import autodukan_logo from "../../assets/images/autoducan_logo.png";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTheme from "@mui/system/useTheme";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { addToCart, getRecentllyViewed } from "./../../services/user";
import EastIcon from '@mui/icons-material/East';
import useMediaQuery from '@mui/material/useMediaQuery';
import toast from "react-hot-toast";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useCart } from "../../utils/CartContext";
import trackEvent from "../../utils/trackEvent";

const Recentllyviewed = ({ handleClick }) => {

    const theme = useTheme();
    const [recentllyViewed, setRecentllyViewed] = useState([]);
    const loggedIn = localStorage.getItem("is_login");
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const [wishlist, setWishlist] = useState([]);
    const [quantity, setQuantity] = useState(1);
    // const [addedToCart, setAddedToCart] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { fetchCartCount } = useCart();


    const handleAddToCart = async (product_id, discount) => {
        if (loggedIn) {
            setOpenBackdrop(true);

            try{
                const response = await addToCart(product_id, quantity, "", discount);
    
                if (response.code === 200 && response.status === "success") {
                    trackEvent("add_to_cart", {
                        product: {
                            user_id: localStorage.getItem("user_id"),
                            product_id: product_id,
                            product_quantity: quantity,
                        },
                    });
                    // setAddedToCart(true);
                    setOpenBackdrop(false);
                    // ToastNotification("Item added to cart", "success");
                    toast.success("Item added to cart", {
                        position: "bottom-center",
                    })
                } else if (response.status === "error" && response.code === 203) {
                    // ToastNotification("Product is out of stock", "error");
                    toast.error("Product is out of stock", {
                        position: "bottom-center",
                    })
                    setOpenBackdrop(false);
                }
                fetchCartCount();
            }catch(e){
                setOpenBackdrop(false);
                toast.error("Something went wrong try again after some time");
                fetchCartCount();
            }finally{
                setOpenBackdrop(false);
            }
        } else {
            navigate("/login");
        }
    };
    // useEffect(() => {
    //     const itemInCart = localStorage.getItem("cartItemIds");
    //     if (itemInCart) {
    //         const cartItems = JSON.parse(itemInCart);
    //         if (cartItems.includes(product2.id)) {
    //             setAddedToCart(true);
    //         }
    //     }
    // }, []);

    const sliderRef = useRef(null);
    const scrollAmount = 300;

    useEffect(() => {
        ReplacementProduct();
    }, [loggedIn]);

    const ReplacementProduct = async () => {
        if (loggedIn) {
            const response1 = await getRecentllyViewed(1);
            if (response1?.code === 200) {
                setRecentllyViewed(response1?.data);
            } else {
                setRecentllyViewed([]);
            }
        }
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {loggedIn && recentllyViewed?.length > 0 && (
                <Box fluid="true" sx={{ textAlign: "center", marginTop: { lg: "40px", xs: "40px" }, marginBottom: { lg: "50px", xs: "40px" } }} >

                    <Box className="App_product" paddingTop={{ lg: "10px", xs: "5px", md: '10px' }}>
                        {!isMobile && (
                            <IconButton
                                sx={{ color: "#12477a" }}
                                onClick={() => {
                                    const container = sliderRef.current;
                                    container.scrollLeft -= scrollAmount;
                                }}
                            >
                                <ArrowBackIosIcon sx={{ fontSize: "1.5rem" }} />
                            </IconButton>
                        )}
                        <Box
                            className="images-container_product"
                            ref={sliderRef}
                            sx={{
                                display: "flex",
                                gap: "10px",
                                overflowX: { xs: "auto", lg: "hidden", md: "hidden", sm: "hidden" },
                                overflowY: "hidden",
                                scrollBehavior: "smooth",
                                transition: "scroll 0.3s ease-in-out",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                "& > *": {
                                    flex: "0 0 auto",
                                    [theme.breakpoints.up("sm")]: {
                                        minWidth: "calc(33.333% - 10px)",
                                    },
                                    [theme.breakpoints.up("md")]: {
                                        minWidth: "calc(50% - 10px)",
                                    },
                                    [theme.breakpoints.up("lg")]: {
                                        minWidth: "calc(25% - 10px)",
                                    },
                                },
                            }}
                        >
                            {recentllyViewed?.map((item, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        border: "1px solid",
                                        borderColor: "#E5E5E5",
                                        maxWidth: "350px",
                                        minWidth: "270px",
                                        cursor: "pointer",
                                        borderRadius: "7px",
                                        position: "relative",
                                        overflow: "visible",
                                        transition: "box-shadow 0.3s, height 0.3s",
                                        minHeight: "193px",
                                        "&:hover": {
                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                            "& .add-to-cart-button": {
                                                opacity: 1,
                                            },
                                        },
                                        "& > *": {
                                            [theme.breakpoints.up("sm")]: {
                                                margin: "0 auto",
                                            },
                                        },
                                    }}
                                    onClick={() => handleClick(item)}
                                >
                                    {Number(item?.price) > item?.discount &&
                                        item?.discount > 0 && (
                                            <Chip
                                                label={`${item?.discount_percent}% off`}
                                                sx={{
                                                    paddingTop: "2px",
                                                    borderRadius: "0px 20px 20px 0px",
                                                    fontSize: "12px",
                                                    height: "22px",
                                                    fontFamily: "'Bebas Neue', sans-serif",
                                                    width: "60px",
                                                    fontWeight: "100",
                                                    backgroundColor: "#ff6633",
                                                    color: "#fff",
                                                    position: "absolute",
                                                    zIndex: "99",
                                                    top: 5,
                                                    left: 5,
                                                }}
                                            />
                                        )}

                                    <Stack direction="row" spacing={0} display={"flex"} >
                                        <CardContent
                                            sx={{
                                                display: "flex",
                                                padding: "5px",
                                                alignItems: "center",
                                                justifyContent: "flex-start",
                                            }}
                                        >
                                            <CardMedia
                                                sx={{
                                                    display: "block",
                                                    width: "100%",
                                                    height: "95px",
                                                    objectFit: "contain",
                                                    // marginTop: "20px",
                                                }}
                                                component="img"
                                                image={
                                                    item.product_image
                                                        ? item.product_image
                                                        : autodukan_logo
                                                }
                                                alt="product"
                                            />
                                        </CardContent>
                                        <CardContent
                                            sx={{
                                                display: "flex",
                                                fontSize: { lg: "13px", xs: "14px" },
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                padding: { lg: "30px 10px 10px 0px", xs: "15px 15px 0px 10px" },
                                                // marginTop: "30px",
                                                fontFamily: "'Barlow', sans-serif",
                                            }}
                                        >
                                            {!isMobile ? (
                                                item?.product_name && (

                                                    <Typography sx={{
                                                        lineHeight: "1.2",
                                                        fontSize: { lg: "18px", xs: "24px" },
                                                        fontWeight: 400,
                                                        marginBottom: "4px",
                                                        fontFamily: "'Bebas Neue', sans-serif",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}>
                                                        {item.product_name.length > 22 ? `${item.product_name.substring(0, 22)}...` : item.product_name}
                                                    </Typography>
                                                )
                                            ) : (
                                                item?.product_name && (
                                                    <Typography sx={{
                                                        lineHeight: "1.2",
                                                        fontSize: { lg: "18px", xs: "24px" },
                                                        fontWeight: 400,
                                                        marginBottom: "4px",
                                                        fontFamily: "'Bebas Neue', sans-serif",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}>
                                                        {item.product_name.length > 15 ? `${item.product_name.substring(0, 15)}...` : item.product_name}
                                                    </Typography>
                                                )
                                            )}
                                            {item?.product_sku && (
                                                <Typography fontFamily="'Barlow', sans-serif" marginTop={"0 !important"} color={"#A0A0A0"} textAlign={"left"}>
                                                    Part No.: {!isMobile ? (item.product_sku.length > 13 ? `${item.product_sku.substring(0, 13)}...` : item.product_sku) : (item.product_sku.length > 7 ? `${item.product_sku.substring(0, 7)}...` : item.product_sku)}
                                                </Typography>
                                            )}
                                            {item?.sku_class && (
                                                <Typography fontFamily="'Barlow', sans-serif" marginTop={"0 !important"} color={"#A0A0A0"}>
                                                    Type : {item?.sku_class}
                                                </Typography>
                                            )}
                                            {/* {item?.brand_name && ( */}
                                            <Typography fontFamily="'Barlow', sans-serif" marginTop={"0 !important"} color={"#A0A0A0"}>
                                                Brand: {!isMobile ?
                                                    (item.brand_name.length > 0 ?
                                                        (item.brand_name.length > 13 ? `${item.brand_name.substring(0, 13)}...` : item.brand_name)
                                                        : '--')
                                                    :
                                                    (item.brand_name.length > 0 ?
                                                        (item.brand_name.length > 7 ? `${item.brand_name.substring(0, 7)}...` : item.brand_name)
                                                        : '--')
                                                }
                                            </Typography>
                                            {/* )} */}
                                            {item?.price == 0 ? (
                                                <Typography fontSize={"16px"} fontWeight={600} sx={{ fontFamily: "'Barlow', sans-serif", color: "#ff0000" }}>
                                                    Currenlty not available
                                                </Typography>
                                            ) : Number(item?.price) > item?.discount && item?.discount > 0 ? (
                                                <>
                                                    <Box display={"flex"}>
                                                        <Typography
                                                            sx={{ fontWeight: "bold", color: "rgba(255, 0, 0, 1)", fontSize: "15px" }}
                                                        >
                                                            ₹{item?.discount}{" "}
                                                        </Typography>
                                                        <Typography
                                                            // margin={"px"}
                                                            color={"#9b9b9b"}
                                                            sx={{
                                                                fontSize: "12px",
                                                                paddingLeft: "5px",
                                                                paddingTop: "2px",
                                                                textDecoration: "line-through",
                                                            }}
                                                        >
                                                            MRP ₹{item?.price}
                                                        </Typography>
                                                    </Box>
                                                </>
                                            ) : (
                                                <>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            // flexDirection: "column",
                                                        }}>
                                                        <Typography sx={{ fontWeight: "bold", color: "rgba(255, 0, 0, 1)", fontFamily: "'Barlow', sans-serif", fontSize: "15px" }}>
                                                            ₹{item?.price}{" "}
                                                        </Typography>
                                                    </Box>
                                                </>
                                            )}
                                            <Box display={"flex"} marginTop={"5px"} alignContent={"center"}>
                                                <Button
                                                    variant="contained"
                                                    endIcon={<EastIcon style={{ fontSize: '15px', paddingBottom: "3px" }} />}
                                                    sx={{
                                                        width: "125px",
                                                        visibility: item.price == 0 || item.price == null ? "hidden" : "visible",
                                                        height: { lg: "26px", xs: "30px" },
                                                        fontSize: "15px",
                                                        overflow: "hidden",
                                                        lineHeight: "7.8px",
                                                        textOverflow: "ellipsis",
                                                        fontFamily: "'Bebas Neue', sans-serif",
                                                        whiteSpace: "nowrap",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#FF6633",
                                                        alignContent: "center",
                                                        '&:hover': {
                                                            backgroundColor: '#FF663e',
                                                        },
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAddToCart(item.id, item.discount_percent,"",1);
                                                    }}
                                                >
                                                    {"Add to Cart"}
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Stack>
                                </Card>
                            ))}
                        </Box>

                        {!isMobile && (
                            <IconButton
                                sx={{ color: "#12477a" }}
                                onClick={() => {
                                    const container = sliderRef.current;
                                    container.scrollLeft += scrollAmount;
                                }}
                            >
                                <ArrowForwardIosIcon sx={{ fontSize: "1.5rem" }} />
                            </IconButton>
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};

export default Recentllyviewed;
